import { all } from "@redux-saga/core/effects";

import { initUsers } from "./initialization/sagas";
import { usersEntriesSagas } from "./Users/sagas";

export function* usersSaga() {
    yield all([
        initUsers(),
        usersEntriesSagas()
    ]);
}